import React,{Component} from 'react'
import './user.css'
import {Container} from 'reactstrap'
import {Link} from 'react-router-dom'
import  { Redirect } from 'react-router-dom' 
import SavedIcon from '../../assets/icons/save.png'
import Together from '../../assets/icons/together.png'
import orderHistory from '../../assets/icons/orderHistory.png'
import Saved from './Saved/Saved'
import Friends from './Friends/Friends'
import OrderHistory from './Orders/OrderHistory'
import * as actionCreators from '../../Actions/Index';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

 class User extends Component{
  constructor(props){
      super(props)
      this.state= {
        SavedProducts: true,
        friendsSavedProducts: false,
        orderHistory: false,
        username: [],
      }
  }
  componentWillMount(){
    this.unlisten = this.props.history.listen((location, action) => {
      this.props.getUserNameByUserID();
  this.setState({username:this.props.username});
  });
  this.props.getUserNameByUserID();
  this.setState({username:this.props.username});
  }
  componentWillReceiveProps(nextProps){
    this.setState({username:nextProps.username});
}
SavedProductsRender = () =>{
  this.setState({SavedProducts: true , friendsSavedProducts:false , orderHistory: false})
}
friendsSavedProductsRender = () =>{
 this.setState({SavedProducts: false , friendsSavedProducts:true , orderHistory: false})
  
}
orderHistoryRender = () =>{
  this.setState({SavedProducts: false , friendsSavedProducts:false , orderHistory: true})
  
}
render(){
  // if(cookies.get("domain") == "SelectFashion" && cookies.get("usfid")) {
  
  return(
  <Container className="UPContainer">
     <div className="parentUP">
      <div className="ULD">
         <div className="URPP">
            <img className="UAI" src={require("../../assets/icons/user.jpg")}/>
         </div>
      </div>
      <div className="URD">
           <div className="UN">
             <h1 className="UNHT">{this.state.username}</h1>
             {/* <a href="https://api.whatsapp.com/send?text=http://selectfashion.pk/inviteFriend/ajhgfbvfg23o233m4546434xx23nm343443
              I am inviting you to join SelectFashion. Lets select fashion together.Friends need suggestions. :)
              " target="_blank" data-action="share/whatsapp/share">Invite Friend</a> */}
           </div>
      </div>
      </div>
      <div className="UPIH">
      <span class="UPIHLO" onClick={this.SavedProductsRender}>
       <img class="PJXu4ll" src={SavedIcon}></img>
     </span>
     <span class="UPIHLO" onClick={this.friendsSavedProductsRender}>
       <img class="PJXu4" src={Together}></img>
     </span>
     <span class="UPIHLO" onClick={this.orderHistoryRender}>
       <img class="PJXu4" src={orderHistory}></img>
     </span>
      </div>
      <div style={{marginBottom: "80px"}}>
      {this.state.friendsSavedProducts ?
      <Friends />
      :null}
       {this.state.SavedProducts ?
      <Saved />
      :null}
      {this.state.orderHistory ?
      <OrderHistory />
      :null}
      </div>
  </Container>
)
//       }
// else{
//   return <Redirect to='/login'  />
// }
}

}
const mapStateToProps=(state)=>(

  {
  username:state.username,
});

const mapDispatchToProps = dispatch => {
  return {
    getUserNameByUserID: () => dispatch(actionCreators.getUserNameByUserID()),
  }
  
}


export default withRouter(connect(mapStateToProps,mapDispatchToProps)(User))